import { render, staticRenderFns } from "./AppleCareCard.vue?vue&type=template&id=3afdd948&scoped=true"
import script from "./AppleCareCard.vue?vue&type=script&lang=js"
export * from "./AppleCareCard.vue?vue&type=script&lang=js"
import style0 from "./AppleCareCard.vue?vue&type=style&index=0&id=3afdd948&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afdd948",
  null
  
)

export default component.exports